import { Pipe, PipeTransform } from '@angular/core';
import { filter } from 'lodash-es';

@Pipe({
  name: 'uiFilter',
  standalone: false  //NOSONAR
})
export class UIFilterPipe implements PipeTransform {
  keysToSearch: string[];
  searchKey: string;

  transform(value: any[], ...args: any): any {
    this.searchKey = args[0]?.toLowerCase();
    this.keysToSearch = args[1];
    if (!value || !this.searchKey) {
      return value;
    }
    return this.filterValues(value);
  }

  filterValues(value) {
    return filter(value, (obj) => {
      return this.keysToSearch.reduce((acc, curr) => {
        return acc || obj.items ? this.filterValues(obj.items) : obj[curr]?.toLowerCase().includes(this.searchKey);
      }, false);
    });
  }

  ignorePropInSearch(prop) {
    if (prop.name === 't_importProps' || prop.name === 't_exportProps' || prop.name === 'lookupConfiguration') {
      return true;
    }
    return false;
  }
}
